import { Component, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { TimeoutError } from 'rxjs/Rx';
import { AuthAccessProvider } from '../core/core.auth';
import { MessageProvider } from '../service/message.service';
import { AppConstants } from './app.constants';

@Component({
    template: "&nbsp;"
})
export class CoreComponent {

    constructor() { }
}

export class SRMError {
    status: number;
    message: string;

    constructor() { }
}

export class BaseResponse {
    status: number;
    message: string;

    constructor() { }
}

export class GlobalFilter {
    dateFrom: Date = null;
    dateTo: Date = null;
    users: SelectItem[] = [];
    usersGroupFilter = false;
    usernames: SelectItem[] = [];

    constructor() { }
}

export class CheckInResponse extends BaseResponse {
    checkInTs: number;
    constructor() {
        super();
    }
}

export class CheckOutResponse extends BaseResponse {
    checkOutTs: number;
    constructor() {
        super();
    }
}

export class CheckedInResponse extends BaseResponse {
    checkInTs: number;
    isCheckedIn: boolean;
    constructor() {
        super();
    }
}

export class PresenceTimeResponse extends BaseResponse {
    hours: number;
    minutes: number;
    hoursValued: number;
    minutesValued: number;

    constructor() {
        super();
    }
}

export class WorkedDateTime {
    hours: number;
    minutes: number;
    date: Date;
    theoreticalTime: number;
    constructor() { }
}

export class WorkedDateTimeResponse extends BaseResponse {
    result: WorkedDateTime[] = [];
    constructor() {
        super();
    }
}

export class EnterCausesResponse extends BaseResponse {
    enterCauses: EnterCause[] = new Array();
    constructor() {
        super();
    }
}

export class ExitCausesResponse extends BaseResponse {
    exitCauses: ExitCause[] = new Array();
    constructor() {
        super();
    }
}

export class AnomalieResponse extends BaseResponse {
    userAnomalies: Anomalia[] = new Array();
    constructor() {
        super();
    }
}

export class Anomalia {
    message: string;
    blocking: boolean = false;
    priority: number = -1;
    date: Date;
    fullname: string;
    userId: number;
    anomaly: string;
    constructor() { }
}

export class EnterCause {
    id: number;
    description: string;
    constructor() {
    }
}

export class ExitCause {
    id: number;
    description: string;
    constructor() {
    }
}

export class UserContext {
    userId: string = null;
    fullName: string = null;
    srmToken: string = null;

    constructor() { }
}

export class UserInfo {
    admin: boolean = false;
    equipmentAdmin: boolean = false;
    ordersMgmt: boolean = false;
    areaManager: boolean = false;
    managedUsers: string[] = [];
    ufficioBodyRental: string = null;
    clienteBodyRental: string = null;
    managedUsersMap: Map<string, string[]> = new Map();

    constructor() { }
}

export class Entry {
    idUser: number;
    idMotivUsc: string;
    idMotivEnt: string;
    date: string;
    entrance: string;
    exit: string;

    constructor() { }
}

export class Presence {
    id: number;
    date: Date;
    userId: number;
    fullName: string;
    begin: Date;
    end: Date;
    tsIn: Date;
    tsOut: Date;
    pausa: number;
    durationHours: number
    durationMinutes: number;
    idMotivUsc: number;
    descMotivUsc: string;
    createdAt: Date;
    updatedAt: Date;
    amenderUserId: number;
    amenderFullname: string;
    ipBegin: string;
    ipEnd: string;
    coordinatesBegin: string;
    coordinatesEnd: string;
    ble_uuid: string;
    idMotivEnt: number;
    descMotivEnt: string;

    constructor() { }
}

export class Activity {
    id: number;
    username: string;
    fullname: string;
    issueId: number;
    issueNo: string;
    issueTitle: string;
    href: string;
    inserted: number;
    activityTypeId: number;
    activityTypeDescription: string;
    comment: string;
    spentHours: number;
    spentMinutes: number;
    isForNewTask: boolean = false;
}

export class ActivityResponse extends BaseResponse {
    activities: Activity[] = new Array();
    totalHours: number;
    totalMinutes: number;
    constructor() {
        super();
    }
}

export class ActivityTypeResponse extends BaseResponse {
    activityTypes: ActivityType[] = new Array();
    constructor() {
        super();
    }
}

export class ActivityType {
    id: number;
    name: string;
    key: string;
    constructor() { }
}

export class Task {
    id: number;
    issueNo: string;
    title: string;
    href: string;
    listItemIcon: string = "";
    constructor() { }
}

export class DetailedTask extends Task {
    state: number;
    closed: boolean;
    createdAt: Date;
    createdAtIso: string;
    updatedAt: Date;
    updatedAtIso: string;
    postedBy: TBGUser;
    assignee: TBGUser;
    status: TaskStatus;
    reforder: string;
    tickettype: TBGTicketType;
    ufficiodicompetenza: TBGUfficio;
    clientecse: TBGCliente;
    description: string;
    priority: TBGPriority;
    category: string;
    percentComplete: number;
    estimatedTime: IssueTime;
    spentTime: IssueTime;

    constructor() {
        super();
    }
}

export class TBGUser {
    buddyName: string;
    dateJoined: Date;
    dispalyName: string;
    id: number;
    lastSeen: Date;
    name: string;
    realname: string;
    username: string;

    constructor() { }
}

export class TaskStatus {
    id: number;
    name: string;

    constructor() { }
}

export class TBGPriority {
    id: number;
    name: string;
    key: string;

    constructor() { }
}

export class IssueTime {
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
    points: number;

    constructor() { }
}

export class TBGTicketType {
    _customfieldId: number;
    _name: String;

    constructor() { }
}

export class TBGUfficio {
    _name: string;
    _project: number;
    _isreleased: boolean;
    _id: number;
}

export class TBGCliente {
    _name: string;
    _project: number;
    _description: string;
    _locked: boolean;
    _isreleased: boolean;
    _releasedate: Date;
    _id: number;
}

export class TBGMilestone {
    id: number;
    name: string;
    //altri campi non utili al momento. li ignoro
}

export class TBGComment {
    commentNumber: number;
    content: string;
    createdAt: Date;
    id: number;
    postedBy: TBGUser;
    systemComment: boolean;
}

export class TaskResponse extends BaseResponse {
    issues: Task[] = new Array();
    constructor() {
        super();
    }
}

export class DetailedTaskResponse extends BaseResponse {
    issues: DetailedTask[] = new Array();
    constructor() {
        super();
    }
}

export class CreateTaskResponse extends BaseResponse {
    issue: Task = null;
    constructor() {
        super();
    }
}

export class ChangeIssueStatusResponse extends BaseResponse {
    constructor() {
        super();
    }
}

export class UserStatistics {
    giorniLavorativiMese: number;
    giorniStraordinariMese: number;
    giorniLavoratiMese: number;
    ferieGodute: number;
    ferieProgrammate: number;
    ferieResidue: number;
    oreMalattia: number;
    oreAltreAssenze: number;
    riepilogoPatrono: string;
}

export class UserStatisticsResponse extends BaseResponse {
    map: UserStatistics;
    constructor() {
        super();
    }
}

export class UserStatisticsProspect {
    userId: number;
    fullname: string;
    oreMese: number;
    oreTeoriche: number;
    oreLavorate: number;
    diffTeoLav: number;
    numGiorniStraordinario: number;
    oreStraordinario: number;
    minutiStraordinario: number;
    numGiorniStraordinarioAutorizzato: number;
    oreStraordinarioAutorizzato: number;
    minutiStraordinarioAutorizzato: number;
    oreFerie: number;
    oreMalattia: number;
    oreAltreAssenze: number;
    oreRichiesteDaApprovare: number;
    totaleOreAssenze: number;
    totalePresenzaOre: number;
    totalePresenzaMinuti: number;
    totalePresenzaOreTs: number;
    totalePresenzaMinutiTs: number;
    numMailAnomalie: number;
    percentualeSmartWorking: number;
    constructor() { }
}

export class UserStatisticsProspectResponse extends BaseResponse {
    prospects: UserStatisticsProspect[] = [];
    constructor() {
        super();
    }
}

export class GruppiLDAPResponse extends BaseResponse {
    gruppi: GruppoLDAP[];
    uffici: string[];
}

export class GruppoLDAP {
    nome: string;
    isDefault: boolean;
}

export class User {
    id: number;
    username: string;
    fullname: string;
    admin: boolean;
    active: boolean;
    tokenTBG: string;
    deviceId: string;
    startDate: Date;
    endDate: Date;
    blockingLevel: number;
    displayLevel: number;
    ipAllowed: string;
    codiceFiscale: string;
    typeUser: string;
    expCheckhr: boolean;
    notes: string;
    ufficio: string[];
    uffici: string[];
    loginLDAPUtente: string;
    pdw: string;
    constructor() { }
}

export class NewUser extends User {
    nome: string;
    cognome: string;
    gruppi: string[];


}

export class UsersResponse extends BaseResponse {
    users: User[] = new Array();
    constructor() {
        super();
    }
}

export class UserData {
    idUser: number;
    tsIni: string;
    numGiorniFerieAnno: number;
    numOreLun: number;
    numOreMar: number;
    numOreMer: number;
    numOreGio: number;
    numOreVen: number;
    numOreSab: number;
    numOreDom: number;
    constructor() { }
}

export class UserDataResponse extends BaseResponse {
    userData: UserData;
    constructor() {
        super();
    }
}

export class UsersWithAnomaliesResponse extends BaseResponse {
    usersWithAnomalies: User[] = new Array();
    constructor() {
        super();
    }
}

export class Project {
    id: number;
    key: string;
    name: string;

    constructor() { }
}

export class ProjectResponse extends BaseResponse {
    userProjects: Project[] = new Array();
    constructor() {
        super();
    }
}

export class TaskType {
    id: number;
    key: string;
    name: string;
    description: string;

    constructor() { }
}

export class TaskTypeResponse extends BaseResponse {
    projectIssueTypes: TaskType[] = new Array();
    constructor() {
        super();
    }
}

export class Field {
    name: string;
    description: string;
    required: boolean = false;
    custom: boolean = false;
    addictional: boolean = false;
    values: any = null;
    value: string;
    placeholder: string = null;
    options: SelectItem[] = [];

    constructor() { }
}

export class FieldResponse extends BaseResponse {
    issueFields: Field[] = new Array();
    constructor() {
        super();
    }
}

export class AbsenceRequest {
    id: number;
    userId: number;
    username: string;
    fullname: string;
    dateBegin: Date = null;
    dateEnd: Date = null;
    createdAt: Date = null;
    causeId: number;
    causeDescription: string;
    approverUserId: number;
    approverFullname: string;
    approvedAt: Date = null;
    updatedAt: Date = null;
    numDaysAbsence: number;
    typeDay: string;
    constructor() { }
}

export class AbsenceRequestResponse extends BaseResponse {
    applications: AbsenceRequest[] = new Array();
    constructor() {
        super();
    }
}

export class AbsenceRequestCountResponse extends BaseResponse {
    count: number;
    constructor() {
        super();
    }
}

export class Absence {
    descMotiv: string;
    fullname: string;
    username: string;
    date: Date;
    userId: number;
    flag: string;
    causeId: number;
    hoursNumber: number;
    causale: string;
    idUserIns: number;
    desUserIns: string;
    tsModif: Date;
    presentNow: boolean;
    tsRequest: Date;
    typeDay: string;
    constructor() { }
}

export class AbsenceResponse extends BaseResponse {
    absences: Absence[] = new Array();
    constructor() {
        super();
    }
}

export class WorkedDaysResponse extends BaseResponse {
    days: Date[] = new Array();
    constructor() {
        super();
    }
}

export class AbsenceCause {
    id: number;
    type: string;
    description: string;
}

export class AbsenceCauseResponse extends BaseResponse {
    absenceCauses: AbsenceCause[] = new Array();
    constructor() {
        super();
    }
}

export class PresenceDetailResponse extends BaseResponse {
    presence: Presence = null;
    constructor() {
        super();
    }
}

export class AnomalyType {
    id: number;
    description: string;
    priority: number;

    constructor() { }
}

export class AnomalyTypeResponse extends BaseResponse {
    anomalyTypes: AnomalyType[] = new Array();
    constructor() {
        super();
    }
}

export class AnomalyLevelsResponse extends BaseResponse {
    levels: number[] = new Array();
    constructor() {
        super();
    }
}

export class UserAbsence {
    userId: number;
    username: string;
    fullname: string;
    absenceCause: string;
    absenceCauseId: number;
    approved: boolean;
    color: string;
    constructor() { }
}

export class DateUserAbsence {
    date: Date;
    userAbsences: UserAbsence[] = [];
    constructor() { }
}

export class DateUserAbsenceResponse extends BaseResponse {
    dateUserAbsences: DateUserAbsence[] = new Array();
    totalOverlapping: number;
    constructor() {
        super();
    }
}

export class YearsResponse extends BaseResponse {
    years: number[] = [];
    constructor() {
        super();
    }
}

export class UserCalendarDay {
    date: Date = null;
    userId: number;
    username: string;
    workday: boolean;
    constructor() { }
}

export class UserCalendarDayResponse extends BaseResponse {
    days: UserCalendarDay[] = [];
    constructor() {
        super();
    }
}

export class ElCheckhr {
    id: number;
    desc: string;
    numGiorniValidita: number;
    numGiorniAlert: number;
    constructor() { }
}

export class CheckhrElementsResponse extends BaseResponse {
    elements: ElCheckhr[] = [];
    constructor() {
        super();
    }
}

export class CheckhrElementResponse extends BaseResponse {
    id: number;
    constructor() {
        super();
    }
}

export class CheckhrUser {
    data: Date;
    idUser: number;
    desUser: string;
    idElCheckhr: number;
    dataScadenza: Date;
    note: string;
    elCheckhr: ElCheckhr;
    constructor() { }
}

export class CheckhrUsersResponse extends BaseResponse {
    checkhrs: CheckhrUser[] = [];
    constructor() {
        super();
    }
}

export class EquipmentType {
    id: number;
    desc: string;
    flagMac: boolean;
    constructor() { }
}

export class EquipmentTypeResponse extends BaseResponse {
    types: EquipmentType[] = [];
    constructor() {
        super();
    }
}

export class EquipmentsRequest {
    desc: string;
    idTipo: number;
    serialNumber: string;
    dataAcquisto: string;
    dataAcquistoDa: string;
    dataAcquistoA: string;
    codCespite: string;
    dataAlienazione: string;
    dataAlienazioneDa: string;
    dataAlienazioneA: string;
    soloAttivi: boolean;
    nonAssegnati: boolean;
    constructor() { }
}

export class Equipment {
    id: number;
    desc: string;
    idTipo: number;
    desTipo: string;
    serialNumber: string;
    dataAcquisto: Date;
    codCespite: string;
    dataAlienazione: Date;
    macAddress: string;
    note: string;
    idAssegnatario: number;
    desAssegnatario: string;
    constructor() { }
}

export class EquipmentsResponse extends BaseResponse {
    equipments: Equipment[] = [];
    constructor() {
        super();
    }
}

export class offertaUtenti {
    reforder: string;
    idutente: number;
    constructor() { }
}

export class ClientsRequest {
    dscliente: string;
    cdc: string;
    email: string;
    referente: string;
    constructor() { }
}

export class Client {
    cdc: string;
    email: string;
    dscliente: string;
    idcliente: number;
    referente: string;
    constructor() { }
}

export class ClientsResponse extends BaseResponse {
    clients: Client[] = [];
    constructor() {
        super();
    }
}

export class ScadenzaRequest {
    reforder: string;
    descrizione: string;
    dtscad: Date;
    importo: number;
    giorni: number;
    numfatt: number;
    dtfatt: Date;
    ticket: string;
    constructor() { }
}

export class Scadenza {
    idscad: number;
    reforder: string;
    dsscad: string;
    dscliente: string;
    dtscad: Date;
    importo: number;
    giorni: number;
    numfatt: string;
    dtfatt: Date;
    ticket: string;
    constructor() { }
}

export class ScadenzaResponse extends BaseResponse {
    scadenze: Scadenza[] = [];
    constructor() {
        super();
    }
}

export class Stima {
    idstima: number;
    dsrichiesta: string;
    codrichiesta: string;
    reforder: string;
    priorita: string;
    tsrichiesta: Date;
    tsrisposta: Date;
    giornate: number;
    accettata: string;
    ticket: string;
    constructor() { }
}

export class StimeResponse extends BaseResponse {
    stime: Stima[] = [];
    constructor() {
        super();
    }
}

export class Statistica {
    refOrder: string;
    descrizione: string;
    giornate: number;
    giornateStimate: number;
    giornateEffettive: number;
    constructor() { }
}

export class StatisticheResponse extends BaseResponse {
    statistiche: Statistica[] = [];
    constructor() {
        super();
    }
}

export class Attivita {
    refOrder: string;
    ticket: string;
    dsAttivita: string;
    giorniEffettivi: number;
    giorniStimati: number; // solo commesse Plafond e Turnkey
    anno: number;
    mese: number;
    href: string; // link al ticket TBG, se ricavabile
    constructor() { }
}

export class AttivitaResponse extends BaseResponse {
    attivita: Attivita[] = [];
    tipologia: string;
    constructor() {
        super();
    }
}

export class DetailAnomlieResponse extends BaseResponse {
    anomalie: boolean[] = [];
    bloccanti: boolean[] = [];
    constructor() {
        super();
    }
}

export class OffersRequest {
    reforder: string;
    dsofferta: string;
    idcliente: number;
    importo: number;
    giornate: number;
    dtinizio: Date;
    dtfine: Date;
    tipologia: string;
    constructor() { }
}

export class Offer {
    reforder: string;
    dsofferta: string;
    idcliente: number;
    dscliente: string;
    importo: number;
    giornate: number;
    dtinizio: Date;
    dtfine: Date;
    tipologia: string;
    reforder_EXT: string;
    dtaccettaz: Date;
    note: string;
    dora: boolean;
    linkdocu: string;
    cdr: string;
    constructor() { }
}

export class OffersResponse extends BaseResponse {
    offers: Offer[] = [];
    constructor() {
        super();
    }
}

export class EquipmentUsersRequest {
    idUser: number;
    idUsers: number[];
    idEquip: number;
    idTipo: number;
    dataInizioAssegnaz: string;
    dataInizioAssegnazDa: string;
    dataInizioAssegnazA: string;
    dataFineAssegnaz: string;
    dataFineAssegnazDa: string;
    dataFineAssegnazA: string;
    soloAttivi: boolean;
    utenteCorrente: boolean;
    constructor() { }
}

export class EquipmentUser {
    id: number;
    idUser: number;
    idEquip: number;
    dataInizioAssegnaz: Date;
    dataFineAssegnaz: Date;
    desUser: string;
    desEquip: string;
    idTipo: number;
    desTipo: string;
    serialNumber: string;
    dataAcquisto: Date;
    codCespite: string;
    dataAlienazione: Date;
    macAddress: string;
    desUserModif: string;
    constructor() { }
}

export class EquipmentUsersResponse extends BaseResponse {
    results: EquipmentUser[] = [];
    constructor() {
        super();
    }
}

export class HolidayReport {
    idUser: number;
    desUser: string;
    oreFerieGodute: number;
    oreFerieProgrammate: number;
    oreFerieResidue: number;
    orePatronoGodute: number;
    orePatronoProgrammate: number;
    constructor() { }
}

export class HolidayReportResponse extends BaseResponse {
    results: HolidayReport[] = [];
    constructor() {
        super();
    }
}

@Pipe({ name: 'presenceDuration' })
export class PresenceDurationPipe implements PipeTransform {
    transform(value: Presence): string {
        if (value) {
            return AppConstants.formatDuration(value.durationHours, value.durationMinutes);
        } else {
            return "";
        }
    }
}

@Pipe({ name: 'activityDuration' })
export class ActivityDurationPipe implements PipeTransform {
    transform(value: Activity): string {
        if (value) {
            return AppConstants.formatDuration(value.spentHours, value.spentMinutes);
        } else {
            return "";
        }
    }
}

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }

    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}

@Pipe({ name: 'daysHours' })
export class DaysHoursPipe implements PipeTransform {
    transform(value: number): string {
        if (value) {
            const giorni: number = value >= 0 ? Math.floor(value) : Math.ceil(value);
            let result = giorni != 0 ? (giorni + ' g ') : '';
            if (giorni !== value) {
                result += ((Math.abs(value) - Math.abs(giorni)) * 8) + ' h';
            }
            return result;
        } else {
            return '0';
        }
    }
}

export class PresenceResponse {
    presences: Presence[] = new Array();
    totalDurationHours: number;
    totalDurationMinutes: number;
    constructor() { }
}

export class ReportConfig {
    desc: string;
    clazz: string;
    paramNames: string[];
    requiredParams: string[];
}

export class ReportsConfigResponse {
    reports: ReportConfig[] = new Array();
}

export class TipoPrenotazione {
    id: number;
    type: string;
    description: string;
}

export class Scrivania {
    idScrivania: number;
    idUserDefault: number;
    nome: string;
    descrizione: string;
    userName: string;
    fullName: string;
    liberaDalDefault: boolean;
    color: string;
    constructor() { };
}

export class Prenotazione {
    idPrenotazione: number;
    idUser: number;
    idScrivania: number;
    data: Date;
    tipo: string;
    flagOccupa: boolean;
    nomeUser: string;
    fullName: string;
    color: string;
    constructor() { };
}

export class RiepilogoScrivaniaStatus {
    disponibile: Boolean;
    scrivania: Scrivania;
    listPrenotazioni: Prenotazione[];
    constructor() { }
}

export class RiepilogoPrenotazioniGiornoResponse extends BaseResponse {
    listRiepilogo: RiepilogoScrivaniaStatus[];
    constructor() {
        super();
    };
}

export class PrenotazioneScrivaniaRequest {
    idScrivania: number;
    dataDa: string;
    dataA: string;
    tipo: string;
    idUtente: number;
    occupa: Boolean;
    constructor() {
        this.idScrivania = null;
        this.dataDa = null;
        this.dataA = null;
        this.tipo = null;
        this.idUtente = null;
        this.occupa = null;
    };
}

export class RicercaPrenotazioniRequest {
    dataDa: Date;
    dataA: Date;
    userIdsList: number[];
}

export class RicercaPrenotazioniResponse {
    prenotazioni: Prenotazione[];
}

export class PrenotazioneSala {
    idPrenotazione: number;
    idUser: number;
    idSala: number;
    tsBegin: Date;
    tsEnd: Date;
    nomeUser: string;
    fullName: string;
    descrizione: string;
    constructor() { };
}

export class PrenotazioneSalaRequest {
    idSala: number;
    hrBegin: string;
    hrEnd: string;
    descrizione: string;
    idUtente: number;
    dataDa: Date;
    dataA: Date;
    constructor() {
        this.idSala = null;
        this.hrBegin = null;
        this.hrEnd = null;
        this.descrizione = null;
        this.idUtente = null;
        this.dataDa = null;
        this.dataA = null;
    };
}

export class RicercaPrenotazioniSalaRequest {
    hrBegin: string;
    hrEnd: string;
    dataDa: Date;
    dataA: Date;
    userIdsList: number[];
}

export class RicercaPrenotazioniSalaResponse {
    prenotazioni: PrenotazioneSala[];
}

export class RiepilogoPrenotazioniSalaGiornoResponse extends BaseResponse {
    listRiepilogo: PrenotazioneSala[];
    constructor() {
        super();
    };
}

export class Document {
    constructor(raw: DocumentResponse) {
        this.id = raw.id;
        this.title = raw.title;
        this.uploadDate = new Date(raw.uploadDate);
        this.read = !!raw.read;
    }
    id: string;
    title: string;
    uploadDate: Date;
    read: boolean;
}

export class DocumentResponse {
    id: string;
    title: string;
    uploadDate: string;
    read: boolean;
}

export class CaptchaResponse {
    captcha: string;
    cookie: string;
}

export class AbsenceInsertionMalattiaResponse extends BaseResponse {
    fromDateCM: string;
    toDateCM: string;
}

export class FileUploadConfiguration {
    file: File;
    targetUsers: number[];
    uploadMode: string;
}

// Descrittore di una modalità di caricamento documenti, così come la espone il servizio
// /documents/uploadModes: il codice è il valore da rimandare al backend, la label è il
// solo testo da mostrare, i flag descrivono la maschera di caricamento da presentare.
export class UploadModeOption {
    constructor(raw: UploadModeResponse) {
        this.code = raw.code;
        this.label = raw.label;
        this.multipleFiles = !!raw.multipleFiles;
        this.userSelection = !!raw.userSelection;
        this.notice = raw.notice;
        this.noticeLevel = raw.noticeLevel;
    }
    code: string;
    label: string;
    multipleFiles: boolean;
    userSelection: boolean;
    // Avviso fisso da mostrare in testa alla maschera, con il relativo tono (INFO o WARNING)
    notice: string;
    noticeLevel: string;
}

export class UploadModeResponse {
    code: string;
    label: string;
    multipleFiles: boolean;
    userSelection: boolean;
    notice: string;
    noticeLevel: string;
}

export class BaseComponent {
    error: SRMError = new SRMError();

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider) { }

    handleError(error) {
        console.error(error);
        this.messageProvider.clearAll();
        if (error instanceof TimeoutError) {
            this.error.message = AppConstants.TIMEOUT_EXPIRED_MSG;
            this.messageProvider.notifyWarning(this.error.message);
        }
        else {
            this.error = JSON.parse(JSON.stringify(error.json()));
            if (!this.error.status || !this.error.message) {
                alert(error);
                this.authAccess.invalidate();
            } else {
                if (this.error.status == 401) {
                    this.error.message = AppConstants.SESSION_EXPIRED_MSG;
                    this.authAccess.invalidate();
                    this.messageProvider.notifyWarning(this.error.message);
                } else {
                    this.messageProvider.notifyError(this.error.message);
                }
            }
        }
    }

    retrieveError(error): string {
        console.error(error);
        if (error instanceof TimeoutError) {
            return AppConstants.TIMEOUT_EXPIRED_MSG;
        }
        else {
            this.error = JSON.parse(JSON.stringify(error.json()));
            if (!this.error.status || !this.error.message) {
                alert(error);
                this.authAccess.invalidate();
                return null;
            } else {
                if (this.error.status == 401) {
                    this.error.message = AppConstants.SESSION_EXPIRED_MSG;
                    this.authAccess.invalidate();
                    this.messageProvider.notifyWarning(this.error.message);
                    return null;
                } else {
                    return this.error.message;
                }
            }
        }
    }

}





// WEBPACK FOOTER //
// ./src/app/core/core.component.ts